document.addEventListener("DOMContentLoaded", function () {
  function getContainer() {
    return document.getElementById("media-info-container");
  }

  function getHeader() {
    return document.querySelector(".section-header-top10");
  }

  function initHotspots() {
    document.querySelectorAll(".top10-hotspot").forEach((dot) => {
      if (!dot.style.getPropertyValue("--shop-the-look-hot-spot-top")) {
        dot.style.setProperty("--shop-the-look-hot-spot-top", "50%");
      }
      if (!dot.style.getPropertyValue("--shop-the-look-hot-spot-left")) {
        dot.style.setProperty("--shop-the-look-hot-spot-left", "50%");
      }
      if (!dot.style.getPropertyValue("--background")) {
        dot.style.setProperty("--background", "255 255 255");
      }
      if (!dot.style.getPropertyValue("--border-color")) {
        dot.style.setProperty("--border-color", "var(--text-color) / 0.15");
      }
      dot.style.setProperty("background-color", "rgb(var(--background))");
    });
  }

  function syncHotspotSide(item, hover) {
    const dot = item.querySelector(".top10-hotspot");
    if (!dot || !hover) return;
    dot.style.setProperty("--shop-the-look-hot-spot-left", "50%");
    dot.style.setProperty("--shop-the-look-hot-spot-top", "50%");
  }

  function getCheckedRadioValues() {
    return new Set(
      Array.from(document.querySelectorAll('input[type="radio"]:checked'))
        .map((el) => el.value)
        .filter(Boolean)
    );
  }

  function animateIn(el) {
    if (!el) return;

    el.classList.remove("enter", "enter-active");
    el.style.display = "block";
    el.classList.add("visible", "enter");

    void el.offsetWidth;

    requestAnimationFrame(() => {
      el.classList.add("enter-active");

      el.addEventListener(
        "transitionend",
        function handler(e) {
          if (e.propertyName === "transform") {
            el.classList.remove("enter", "enter-active");
            el.removeEventListener("transitionend", handler);
          }
        },
        { once: true }
      );
    });
  }

  function updateTop10Visibility() {
    const container = getContainer();
    const header = getHeader();

    if (!container) return;

    const groups = Array.from(container.querySelectorAll(".media-info"));
    const checked = getCheckedRadioValues();

    container.style.display = groups.length > 0 ? "block" : "none";

    let toShow = null;

    for (const el of groups) {
      const values = (el.dataset.values || "")
        .split("|")
        .map((v) => v.trim())
        .filter(Boolean);

      if (values.some((v) => checked.has(v))) {
        toShow = el;
        break;
      }
    }

    groups.forEach((el) => {
      if (el !== toShow) {
        el.style.display = "none";
        el.classList.remove("visible", "enter", "enter-active");
      }
    });

    if (toShow) {
      if (toShow.style.display === "none" || !toShow.classList.contains("visible")) {
        animateIn(toShow);
      } else {
        toShow.style.display = "block";
        toShow.classList.add("visible");
      }
    }

    if (header) {
      header.style.display = toShow ? "block" : "none";
    }
  }

  function bindScrollItemClicks() {
    if (window.innerWidth <= 500) {
      document.querySelectorAll(".scroll-item").forEach(function (item) {
        if (!item.dataset.bound) {
          item.dataset.bound = "true";

          item.addEventListener("click", function () {
            const hover = item.querySelector(".hover-text");
            const image = item.querySelector("img");
            const isVisible = hover.classList.contains("visible");

            document
              .querySelectorAll(".scroll-item .hover-text.visible")
              .forEach(function (otherHover) {
                if (otherHover !== hover) {
                  otherHover.classList.remove("visible");
                  otherHover
                    .closest(".scroll-item")
                    ?.querySelector("img")
                    ?.classList.remove("zoomed");
                }
              });

            if (isVisible) {
              hover.classList.remove("visible");
              image?.classList.remove("zoomed");
            } else {
              hover.classList.remove("left");
              hover.style.visibility = "hidden";
              hover.style.display = "block";

              requestAnimationFrame(() => {
                const rect = hover.getBoundingClientRect();
                if (rect.right > window.innerWidth) {
                  hover.classList.add("left");
                }

                hover.style.visibility = "";
                hover.style.display = "";

                requestAnimationFrame(() => {
                  hover.classList.add("visible");
                  image?.classList.add("zoomed");
                  syncHotspotSide(item, hover);
                });
              });
            }
          });
        }
      });
    }
  }

  document.querySelectorAll(".hover-close").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      const hover = btn.closest(".hover-text");
      const image = hover.closest(".scroll-item")?.querySelector("img");
      hover.classList.remove("visible");
      image?.classList.remove("zoomed");
    });
  });

  document.querySelectorAll(".scroll-item").forEach((item) => {
    const hover = item.querySelector(".hover-text");
    syncHotspotSide(item, hover);
  });

  window.addEventListener("resize", () => {
    bindScrollItemClicks();
    initHotspots();
  });

  const mediaQuery = window.matchMedia("(max-width: 500px)");
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener("change", (e) => {
      if (e.matches) bindScrollItemClicks();
    });
  }

  initHotspots();
  bindScrollItemClicks();

  updateTop10Visibility();

  document.addEventListener("change", function (e) {
    if (e.target && e.target.matches('input[type="radio"]')) {
      updateTop10Visibility();
    }
  });

  setInterval(updateTop10Visibility, 300);
});